module.exports = __webpack_public_path__ + "img/first-day-5.c09b0343.png";